import i18n from 'i18next';
import {reactI18nextModule} from 'react-i18next';
import config from '../config';
import translationDK from './locales/dk/translation.json';

i18n
  .use(reactI18nextModule)
  .init({
    resources: {
      dk: {
        translation: translationDK
      }
    },
    lng: process.env.REACT_APP_FORCE_LANG || config.country,
    fallbackLng: "dk",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;